module.exports = __webpack_public_path__ + "img/law_31.dfbca925.png";